import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Unavailable from 'Catalog/Availability/Unavailable'
import { CashBack, RegularPriceWrapper, PriceWrapper, InstallmentsWrapper } from './'
import { ToggleFeature, features } from 'features/ToggleFeature'

const convertMoney = (value) => {
  return value.toLocaleString('pt-br', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

const DisplayCash = ({ price, regularPrice, hasCashBack, currency, ruleCashBack, showInstallments, sku, vendorId }) => price ? (
  <Fragment>
    {
      (price < regularPrice) ? (
        <RegularPriceWrapper ariaLabel={'de R$ ' + convertMoney(regularPrice)} className='d-block d-sm-none d-lg-block'>
          de R$ { convertMoney(regularPrice) }
        </RegularPriceWrapper>
      ) : (
        <span className='d-inline-block d-sm-none d-lg-inline-block'>&nbsp;</span>
      )
    }
    <PriceWrapper ariaLabel={'por R$ ' + convertMoney(price) + (showInstallments ? ' à vista no cartão' : '')}>
      {
        showInstallments ? (
          <Fragment>
            {
              (price < regularPrice) && (
                <span className='d-inline-block d-sm-none d-lg-inline-block pr-1'>{`por`}</span>
              )
            }
            <span className='txt-title'>R$ {convertMoney(price)}</span> à vista no cartão
          </Fragment>
        ) : (
          <Fragment>
            {
              (price < regularPrice) && (
                <span className='d-inline-block d-sm-none d-lg-inline-block pr-1'>{`por`}</span>
              )
            }
            <span className='txt-title'>R$ {convertMoney(price)}</span>
          </Fragment>
        )
      }
    </PriceWrapper>
    <CashBack showInstallments={showInstallments} price={price} hasCashBack={hasCashBack} currency={currency} ruleCashBack={ruleCashBack} />
    <InstallmentsWrapper showInstallments={showInstallments} sku={sku} vendorId={vendorId} currentPrice={price} hasCashBack={hasCashBack} ruleCashBack={ruleCashBack} currency={currency} />
    {
      !showInstallments && (
        <ToggleFeature feature={features.CashBackBF} price={price} hasCashBack={hasCashBack} currency={currency} ruleCashBack={ruleCashBack} />
      )
    }

  </Fragment>
) : <Unavailable />

DisplayCash.propTypes = {
  sku: PropTypes.string,
  vendorId: PropTypes.string,
  price: PropTypes.number,
  regularPrice: PropTypes.number,
  hasCashBack: PropTypes.bool,
  ruleCashBack: PropTypes.string,
  currency: PropTypes.shape({
    decimalPlaces: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  showInstallments: PropTypes.bool
}

export default DisplayCash



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/DisplayCash.js